var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { ICON_SIZES, STROKE_WIDTH_DEFAULT, STROKE_WIDTH_SMALL, } from '../icon.constants';
import styles from './Icon.module.css';
const COLOR_CLASS_MAP = {
    accent: styles.Accent,
    brand: styles.Brand,
    'brand-indigo': styles.BrandIndigo,
    default: styles.Default,
    inverted: styles.Inverted,
    informative: styles.Informative,
    negative: styles.Negative,
    positive: styles.Positive,
    warning: styles.Warning,
};
const SIZE_CLASS_MAP = {
    xxsmall: styles.SizeXXSmall,
    xsmall: styles.SizeXSmall,
    small: styles.SizeSmall,
    middle: styles.SizeMiddle,
    large: styles.SizeLarge,
    xl: styles.SizeXL,
};
export const Icon = ({ 'aria-label': ariaLabel, className, color, 'data-testid': testId, fillOpacity = '0.01', onClick, ref, size = ICON_SIZES.middle, SvgComponent, }) => {
    const strokeWidth = size === ICON_SIZES.xsmall || size === ICON_SIZES.xxsmall
        ? STROKE_WIDTH_SMALL
        : STROKE_WIDTH_DEFAULT;
    return (_jsx(SvgComponent, { className: C(styles.Icon, SIZE_CLASS_MAP[size], color && COLOR_CLASS_MAP[color], className), ...(ariaLabel
            ? { 'aria-label': ariaLabel, role: 'img' }
            : { 'aria-hidden': true }), "data-testid": testId, fillOpacity: fillOpacity, onClick: onClick, ref: ref, strokeWidth: strokeWidth }));
};
_react_refresh_temp_1 = Icon;
$RefreshReg$(_react_refresh_temp_1, "Icon");
